import { PromptChatAdapter } from '../../components/Chat/PromptChatAdapter';
import { designerChatAgentIds, designerChatScopes, useDesignerChatAdapter } from '../../components/Chat/useDesignerChatAdapter';

export function usePlanningChatAdapter(projectId: string | undefined, domainStoryId: string | undefined, isAvailable: boolean): PromptChatAdapter {
	return useDesignerChatAdapter({
		scopeName: designerChatScopes.planning,
		agentId: designerChatAgentIds.analyst,
		targetId: projectId,
		isAvailable: isAvailable && !!projectId,
		missingTargetMessage: 'Open a planning project before starting a conversation.',
		messageAttributes: () => ({ DomainStoryId: domainStoryId }),
	});
}
